import type { QueryFunctionContext } from '@tanstack/react-query';
import { WorkspacesService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { adminWorkspacesKeys } from 'app/queries/adminWorkspaces/adminWorkspacesKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof adminWorkspacesKeys.teamsByWorkspace>>;

export const createFetchAdminWorkspaceTeamsQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ workspaceId }], signal }: TParams) =>
    call(() => cancelOnSignal(WorkspacesService.adminGetTeams({ wsid: workspaceId }), signal));
